import SectionHeading from "@/components/feature/SectionHeading";

const reasons = [
  {
    icon: "ri-file-list-3-line",
    title: "只做时间线整理",
    desc: "同一件事按发生顺序记录，前后文完整保留，方便你自己判断。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "不碰个人隐私",
    desc: "涉及私域聊天、身份信息与未经证实指控的内容，一律不收录。",
  },
  {
    icon: "ri-links-line",
    title: "标注来源类型",
    desc: "每条进展都会说明来自公开渠道还是多方转述，来源不清的会直接标注。",
  },
  {
    icon: "ri-time-line",
    title: "热度会自然回落",
    desc: "话题不再被讨论时，实时楼同步收束，留下可回查的完整记录。",
  },
];

export default function WhySection() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="内容原则"
        title="我们怎么整理一个热点"
        desc="热闹归热闹，梳理归梳理——这是吃瓜前线与普通信息流最大的不同。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {reasons.map((item) => (
          <div
            key={item.title}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}